"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var InsightsIcon = function InsightsIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-id": "icon-insights",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: props.width || "70px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "80.5",
    cy: "15.5",
    r: "2.5"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M48,96A48,48,0,1,1,75.57,8.72,2,2,0,1,1,73.27,12,44,44,0,1,0,84,22.73a2,2,0,1,1,3.27-2.3A48,48,0,0,1,48,96Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M60.71,47a1.49,1.49,0,0,1-1.34-.82l-4.16-8.32L49.05,44a1.5,1.5,0,0,1-1.3.42,1.53,1.53,0,0,1-1.11-.81L41.55,33.45a1.5,1.5,0,0,1,2.69-1.34l4.16,8.32,6.16-6.17a1.53,1.53,0,0,1,1.3-.42,1.49,1.49,0,0,1,1.1.81l5.09,10.18a1.51,1.51,0,0,1-.67,2A1.56,1.56,0,0,1,60.71,47Z"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M40.35,78.06a2,2,0,0,1-2-2V69l-2.3,1.06a1.53,1.53,0,0,1-.41.14,6.17,6.17,0,0,1-5.31-1.1,6,6,0,0,1-2.17-4.78V57.68h-.72a4.31,4.31,0,0,1-3.79-2.27,4.46,4.46,0,0,1,.08-4.52l4.4-8.43,0-2.07A22.36,22.36,0,1,1,65.32,57.18a2,2,0,0,1-2.65-3,18.36,18.36,0,1,0-30.5-13.78l0,2.58a2,2,0,0,1-.23.9l-4.7,9a.54.54,0,0,0-.05.59.35.35,0,0,0,.29.21h2.72a2,2,0,0,1,2,2v8.65A2,2,0,0,0,32.85,66a2.17,2.17,0,0,0,1.74.36l4.92-2.29a2,2,0,0,1,2.85,1.81v8.18l17.73,0,0-6a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2l-.05,8a2,2,0,0,1-2,2l-21.72.07Z"
  }), _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "61.99",
    cy: "61.75",
    r: "2.5"
  }), _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "60.72",
    cy: "45.48",
    r: "2.55"
  }), _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "55.63",
    cy: "35.29",
    r: "2.55"
  }), _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "47.99",
    cy: "42.93",
    r: "2.55"
  }), _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "42.9",
    cy: "32.75",
    r: "2.55"
  }))));
};

var _default = InsightsIcon;
exports["default"] = _default;